// extracted by mini-css-extract-plugin
module.exports = {"table":"table--3iAK3","title":"title--3_FMD"};